import { actionable, resourceable } from '@/store/mixins'

export default {
  namespaced: true,
  mixins: [
    resourceable({ 
      name: 'contractWorks',
      from: ({ api }, { projectId, contractId, taskId, withWorkType, withFactInUnitsAll, withFactInUnitsApproved, withFactInUnitsCreated, withFactInUnitsFirstStage, withFactInUnitsSecondStage, withBlockedWorks, withKs2Errors, withRejectionsTaskSource, sort } = {}) => {
        const payload = {
          params: {
            include: [
              withWorkType && 'work_type',
              withRejectionsTaskSource && 'task_rejections.task_source'
            ].filter(is),
            append: [
              withKs2Errors && 'ast_acts_ks2_errors',
              withFactInUnitsAll && 'fact_in_units_all',
              withFactInUnitsApproved && 'fact_in_units_approved',
              ...taskId && [
                withFactInUnitsCreated && 'fact_in_units_acceptance_of_work_created',
                withFactInUnitsFirstStage && 'fact_in_units_acceptance_of_work_first_stage_finished',
                withFactInUnitsSecondStage && 'fact_in_units_acceptance_of_work_second_stage_finished'
              ] || []
            ].filter(is),
            ...sort && { sort }
          }
        }

        if (taskId) return api.ast.getContractWorksByTask({ projectId, contractId, taskId, payload }).then(data => withBlockedWorks ? data : data.filter(x => !x.blocked_at))
        return api.ast.getContractWorksByContract({ projectId, contractId, payload }).then(data => withBlockedWorks ? data : data.filter(x => !x.blocked_at))
      }
    }),

    resourceable({
      name: 'contracts',
      from: ({ api }, { projectId, contractorId, withWorks, withWorkType, withPartnerOrganization, withOrganization, sort = '-dt_create', compact = false } = {}) => {
        const params = {
          filter: {
            ...contractorId && { contractor_id: contractorId }
          },
          include: [
            withWorks && !withWorkType && 'works',
            withWorkType && 'works.work_type',
            withPartnerOrganization && !withOrganization && 'partner_organization',
            withOrganization && 'partner_organization.organization.organizations_projects.user'
          ].filter(is),
          // TODO@pass-from-args after 'works.smeta_number.self' implementation for api.ast.getContracts 
          sort: compact ? 'works.smeta_number.self' : sort
        }

        const fetch = compact ? api.ast.getContractsCompact : api.ast.getContracts

        return fetch({
          projectId,
          payload: { params }
        })
      }
    }),

    resourceable({
      name: 'workFacts',
      from: ({ api }, { projectId, contractId, taskId } = {}) => {
        if (taskId) return api.ast.getWorkFactsByTask({ projectId, contractId, taskId })
        return api.ast.getWorkFactsByContract({ projectId, contractId })
      }
    }),

    actionable({
      name: 'report',
      loadable: true,
      at: ({ api }, { projectId, type, from, to, all = false } = {}) => {
        return api.ast.getAstReport({ 
          projectId, 
          payload: {
            type, from, to,
            used_in_report_common: all
          } 
        })
      }
    }),

    actionable({
      name: 'worksEvolve',
      loadable: true,
      at: ({ api }, { projectId, astWorkIds, usedInReport } = {}) => {
        return api.ast.setWorksEvolve({
          projectId,
          payload: {
            ast_work_ids: astWorkIds,
            used_in_report_common: usedInReport
          }
        })
      }
    })
  ],
  state: {
    info: {},
    status: {}
  },
  getters: {
    getInfo: state => state.info?.data,
    getBimStatus: state => state.status?.data
  },
  mutations: {
    EDIT_INFO: (state, payload) => state.info = payload,
    EDIT_STATUS: (state, payload) => state.bimStatus = payload
  },
  actions: {
    getAstInfo: async function({ commit }, { project }) {
      const { data } = await this.$api.projectsV2.astInfo(project)
      commit('EDIT_INFO', { data: data.data })

      return data.data

      // if(!data.data?.autodesk_hub_id) return
      // let statusData = await this.$api.projectsV2.astInfo(project)
      // commit('EDIT_STATUS', statusData.data)
      // return data.data
    }
  }
}

